export const OPERATOR_STATUSES = {
  invited: "invited",
  set: "set",
};

// export const PREFIX = "http://localhost:5500";
export const PREFIX = "";
